// dashboardState.js
export function initialDashboardState(store) {
    return {
        openSections: null,
        isMobile: false,
        axiosCallInProgress: false,
        vh1Value: 55,
        vh2Value: 65,
        vh3Value: 90,
        badgepack_token: '',
        local: {},
        books: [],
        pages: [],
        bookFilter: [],
        search_tile: "",
        side_bar_page: false,
        fetched_book_modify_obj: [],
        withUpdates: [],
        responseDataObj: [],
        user_email: store.getters.auth_user,
        user_username: store.getters.auth_username,
        user_store: 'Web',
        date_now: new Date().toISOString().split('T')[0], // instead of this.datenow()
        time_now: new Date().toLocaleTimeString(),       // instead of this.getClockTime()
        update_modal: false,
        book_to_update: '',
        dynamic_mergecodes: {},
        file_uploads: [],
        uploaded_file_name: '',
        if_condition: {},
        obj: { html: 'Loading...' },
        tile_loaded: false,
        str_concat: '',
        tile_open_clear: [],
        tile_complete_clear: [],
        main_data: {},
        ip_public: '',
        ip_location: '',
        loaderTrigger: false,
        validation: {},
        book_w_update: [],
        bp_integration: [],
        prepObjStatus: false,
        message_url: {},
        book_mergecodes_length: 0,
        url_get_options: [],
        scrolled: true,
        submittable: false,
        isThereTile: true,
        newloaded: store.getters.newload,
        newload_data: [],
        preload_books: [],
        synced_books: [],
        checkedBooks: [],
        selectAllBooks: 1,
        syncButton: 'Continue',
        allowLightbox: false,
        current_icon: '',
        load_current_icon: false,
        phone_icon: 'mobile-screen-button',
        font_weight: 'light', // solid, light, regular
        totalpages: 0,
        currentPage: 1,
        currentStep: '',
        nextbtn: 'Next',
        typeOfInput: '',
        pageloading: false,
        other_options: [],
        tile_option_index: 0,
        user_action: 'forward',
        temp_semantic_search_query: '',
        semantic_search_query: '',
        semantic_search_tile: [],
        isSemanticSearching: false,
        processedTiles: 0,
        totalTiles: 0,
        stopProcessing: false,
        showPopup: false,
        semanticerrorMessage: '',
        searchElapsedTime: 0,
        elapsedPerTile: 0,
        abortController: null,
        frequentTilesCurrentBook: [],
        frequentTilesLoading: false,
        frequentTilesError: null,
        frequentTilesRequestId: 0,
        isSearchInputActive: false,
        lastFrequentTrackTileId: null,
        lastFrequentTrackBookCode: null,
        lastFrequentTrackAt: 0,
    }
}
